import { ConversationKind, ConversationWhereInput } from '@/types/schema';

interface BuildHouseholdConversationFiltersParams {
  canEditHousehold: boolean;
  currentUserId: string;
}

/**
 * The OR branches deciding which of a household's conversations the current
 * user sees in the chat's conversation list.
 *
 * A chat is private to whoever started it. Validation questions are different:
 * they're asked of the household rather than of one user, and answered by
 * whoever gets to them first, so they're listed for everyone who can act on
 * them — which means users who can edit the household. Read-only users see only
 * their own chats.
 */
export function buildHouseholdConversationFilters({
  canEditHousehold,
  currentUserId,
}: BuildHouseholdConversationFiltersParams): ConversationWhereInput[] {
  const ownChats: ConversationWhereInput = {
    createdBy: currentUserId,
    kind: ConversationKind.HouseholdChat,
  };

  if (!canEditHousehold) {
    return [ownChats];
  }

  return [ownChats, { kind: ConversationKind.ValidationQuestions }];
}
